import ClipboardJS from 'clipboard';
import { _NEW_LINE, charsMappingFromURL } from '../components/constants';

export function copyToClipboard(text:string) {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator.clipboard.writeText() is available
    navigator.clipboard.writeText(text).then(function() {
      //console.log(`Copied ${text} to clipboard`);
    }, function(err) {
      console.error('Could not copy text: ', err);
    });
  } else {
    // navigator.clipboard.writeText() is not available. Use ClipboardJS as a fallback.
    let clipboard = new ClipboardJS('.btn', {
      text: function() {
        return text;
      }
    });

    clipboard.on('success', function(e) {
      //console.log(`Copied ${text} to clipboard`);
      e.clearSelection();
    });

    clipboard.on('error', function(e) {
      //console.error('Action:', e.action);
      console.error('Trigger:', e.trigger);
    });
  }
}

export function convertArrayToText(arr: string[]): string {
  return arr.map(str => str === _NEW_LINE ? "\n" : charsMappingFromURL(str)).join(" ");
}


